import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { cn } from '@ui/primitives/utils';
import { AlertCircle } from 'lucide-react';
/**
 * Error display content.
 *
 * @param error Error instance, uses as a render flag.
 * @param icon Optional custom alert icon.
 * @param className Optional root className.
 */ const Error = (param)=>{
    let { error, icon, className } = param;
    if (!error) {
        return null;
    }
    return /*#__PURE__*/ _jsxs("div", {
        className: cn('w-full text-muted-foreground/80 text-center px-2 py-10 text-sm rounded-md border border-border bg-muted', '[&>svg]:text-turquoise-500 [&>svg]:w-[35px] [&>svg]:h-[35px]', '[&>p]:font-normal [&>p]:text-sm [&>p]:leading-[120%] [&>p]:m-0', className),
        children: [
            icon !== null && icon !== void 0 ? icon : /*#__PURE__*/ _jsx(AlertCircle, {
                className: "mx-auto"
            }),
            /*#__PURE__*/ _jsx("p", {
                children: error.message
            })
        ]
    });
};
export { Error as DisplayError, Error };
/**
 * Generic ze-sdk error display component. Accepts any ze-sdk generated error type with full type inference.
 *
 * @param error Ze-sdk error instance (null/undefined if no error)
 * @param icon Optional custom alert icon
 * @param className Optional root className
 */ export const ZeSdkError = (param)=>{
    let { error, className, icon } = param;
    if (!error) {
        return null;
    }
    return /*#__PURE__*/ _jsxs("div", {
        className: cn('w-full text-muted-foreground/80 text-center px-2 py-10 text-sm rounded-md border border-border bg-muted', '[&>svg]:text-turquoise-500 [&>svg]:w-[35px] [&>svg]:h-[35px]', '[&>p]:font-normal [&>p]:text-sm [&>p]:leading-[120%] [&>p]:m-0', className),
        children: [
            icon !== null && icon !== void 0 ? icon : /*#__PURE__*/ _jsx(AlertCircle, {
                className: "mx-auto"
            }),
            /*#__PURE__*/ _jsx("h3", {
                children: error.statusCode
            }),
            /*#__PURE__*/ _jsx("p", {
                children: error.message
            })
        ]
    });
};
